import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { About } from './components/About';
import { Events } from './components/Events';
import { Gallery } from './components/Gallery';
import { Services } from './components/Services';
import { Timeline } from './components/Timeline';
import { Chapter1 } from './components/Chapter1';
import { Chapter2 } from './components/Chapter2';
import { Chapter3 } from './components/Chapter3';
import { Chapter4 } from './components/Chapter4';
import { Tapasya2 } from './components/Tapasya2';
import { Chapter5 } from './components/Chapter5';
import { Chapter7 } from './components/Chapter7';
import { Chapter8 } from './components/Chapter8';
import { Chapter9 } from './components/Chapter9';
import { Chapter10 } from './components/Chapter10';
import { Chapter11 } from './components/Chapter11';
import { Chapter12 } from './components/Chapter12';
import { Chapter13 } from './components/Chapter13';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';

import './custom.css'
import { Contact } from './components/Contact';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/about' component={About} />
        <Route path='/events' component={Events} />
        <Route path='/gallery' component={Gallery} />
        <Route path='/services' component={Services} />
        <Route path='/timeline' component={Timeline} />
        <Route path='/Chapter1' component={Chapter1} />
        <Route path='/Chapter2' component={Chapter2} />
        <Route path='/Chapter3' component={Chapter3} />
        <Route path='/Chapter4' component={Chapter4} />
        <Route path='/tapasya2' component={Tapasya2} />
        <Route path='/Chapter5' component={Chapter5} />
        <Route path='/Chapter7' component={Chapter7} />
        <Route path='/Chapter8' component={Chapter8} />
        <Route path='/Chapter9' component={Chapter9} />
        <Route path='/Chapter10' component={Chapter10} />
        <Route path='/Chapter11' component={Chapter11} />
        <Route path='/Chapter12' component={Chapter12} />
        <Route path='/Chapter13' component={Chapter13} />
        <Route path='/counter' component={Counter} />
        <Route path='/fetch-data' component={FetchData} />
        <Route path='/contact' component={Contact} />
      </Layout>
    );
  }
}
